import Cookies from 'js-cookie';
import {
  CompareGridEventNames,
  CompareGridLocations,
} from './trackCompareGridEvents';

export const COMPARE_TABLE_CLICK_COOKIE = 'compareTableClick';

export interface CompareTableClickCookieData {
  eventName: CompareGridEventNames.ClickCompareTable;
  interactionLocation: CompareGridLocations;
  linkUrl: string;
  linkText: string;
  index?: number;
  path?: string;
}

const setCompareTableClickCookie = (data: CompareTableClickCookieData) => {
  Cookies.set(COMPARE_TABLE_CLICK_COOKIE, JSON.stringify(data));
};

export default setCompareTableClickCookie;
